import { DefaultToolRenderer } from './DefaultToolRenderer'
import { PlaceToolRenderer } from './PlaceToolRenderer'
import { TransportationToolRenderer } from './TransportationToolRenderer'
import { HotelToolRenderer } from './HotelToolRenderer'
import { TOOL_NAMES } from './constants'
import type { ToolRenderer, ToolRendererRegistry } from './types'

// Import custom renderers here as they are created
// import { ImageryToolRenderer } from './ImageryToolRenderer'

/**
 * Registry mapping tool names to their custom renderer components.
 * Add new tool renderers here to enable custom rendering for specific tools.
 */
const toolRendererRegistry: ToolRendererRegistry = {
  [TOOL_NAMES.PLACE]: PlaceToolRenderer,
  [TOOL_NAMES.TRANSPORTATION_SEARCH]: TransportationToolRenderer,
  [TOOL_NAMES.HOTEL_SEARCH]: HotelToolRenderer,
  // Add more custom renderers as they are implemented:
  // [TOOL_NAMES.IMAGERY_DISPLAY]: ImageryToolRenderer,
  // [TOOL_NAMES.RESTAURANT_SEARCH]: RestaurantToolRenderer,
  // [TOOL_NAMES.ACTIVITY_SEARCH]: ActivityToolRenderer,
}

/**
 * Get the appropriate renderer component for a given tool name.
 * Falls back to DefaultToolRenderer for unknown tools.
 */
export function getToolRenderer(toolName: string): ToolRenderer {
  return toolRendererRegistry[toolName] || DefaultToolRenderer
}

/**
 * Register a custom renderer for a tool name.
 * Useful for dynamic registration or testing.
 */
export function registerToolRenderer(toolName: string, renderer: ToolRenderer): void {
  toolRendererRegistry[toolName] = renderer
}
